import { render, staticRenderFns } from "./addPostCategory.vue?vue&type=template&id=04fbd33a&"
import script from "./addPostCategory.vue?vue&type=script&lang=js&"
export * from "./addPostCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports